import React from 'react';

type TopControllerWrapperProps = {
  children: React.ReactNode;
};

export const TopControllerWrapper = (props: TopControllerWrapperProps) => (
  // onKeyDown is a hack to prevent the radix item from being autofocused 
  <div className="p-0" onKeyDown={(e) => e.stopPropagation()}>{props.children}</div>
);
